export interface NotificationPreferences {
  marketingMessages: boolean;
  statusReminders: boolean;
  wishlistAlerts: boolean;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  marketingMessages: false,
  statusReminders: true,
  wishlistAlerts: true,
};

const NOTIFICATION_STORAGE_KEY = "applykitty.account.notifications";

export function readNotificationPreferences(): NotificationPreferences {
  try {
    const stored = JSON.parse(
      window.localStorage.getItem(NOTIFICATION_STORAGE_KEY) ?? "{}",
    ) as Partial<NotificationPreferences>;
    return { ...DEFAULT_NOTIFICATION_PREFERENCES, ...stored };
  } catch {
    return { ...DEFAULT_NOTIFICATION_PREFERENCES };
  }
}

export function writeNotificationPreferences(preferences: NotificationPreferences): void {
  try {
    window.localStorage.setItem(NOTIFICATION_STORAGE_KEY, JSON.stringify(preferences));
  } catch {
    // Preferences are non-critical and remain usable in memory when storage is unavailable.
  }
}
